<template>
    <div
        :class="{
            [theme.wrapper]: true,
            [theme.header]: filter.location === 'header',
            [theme.menu]: filter.location !== 'header',
        }"
    >
        <div :class="theme.group">
            <div :class="theme.label">
                {{ filter.label }}
            </div>
            <div :class="theme.field">
                <select v-model="filter.current_value" class="form-control form-control-sm">
                    <option
                        v-for="(option, index) in options"
                        :key="`option-${index}`"
                        :value="option.value"
                        v-text="option.key"
                    />
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import Common from './mixins/Common.vue';

export default {
    mixins: [Common],
    props: {
        data: Object,
        filter: Object,
    },
    computed: {
        options() {
            return this.filter.options;
        },
        isActive() {
            return this.filter.current_value !== this.filter.inactive_value;
        },
    },
    watch: {
        'filter.current_value': function () {
            this.updateDisplayData();
        },
    },
    mounted() {
        if (this.isActive) {
            this.updateDisplayData();
        }
    },
    methods: {
        updateDisplayData() {
            this.filter.display_data = [
                {
                    label: this.filter.label,
                    operator: this.filter.operator,
                    value: this.getCurrentKey(),
                },
            ];

            this.bus.$emit('filter-changed');
        },
        getCurrentKey() {
            return this.filter.options.find(x => x.value == this.filter.current_value).key;
        },
    },
};
</script>

<style lang="scss" module></style>
<style
    lang="scss"
    module="theme_default"
    src="./../css/themes/default/select_list_filter.scss"
></style>
<style
    lang="scss"
    module="theme_simple"
    src="./../css/themes/simple/select_list_filter.scss"
></style>
